import { useState, useEffect, lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";

const About = lazy(() => import("@/components/About"));
const Services = lazy(() => import("@/components/Services"));
const Gallery = lazy(() => import("@/components/Gallery"));
const Testimonials = lazy(() => import("@/components/Testimonials"));
const Contact = lazy(() => import("@/components/Contact"));
const Appointment = lazy(() => import("@/components/Appointment"));
const Footer = lazy(() => import("@/components/Footer"));

const Home = () => {
  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  const [showPhotosPopup, setShowPhotosPopup] = useState(false);

  useEffect(() => {
    let lenisInstance = null;
    let rafId = null;
    let isMounted = true;

    const initLenis = async () => {
      try {
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduceMotion || !isMounted) return;

        const Lenis = (await import("@studio-freight/lenis")).default;
        if (!isMounted) return;

        lenisInstance = new Lenis({
          duration: 1.1,
          easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
          smooth: true,
        });

        const raf = (time) => {
          if (!isMounted || !lenisInstance) return;
          lenisInstance.raf(time);
          rafId = requestAnimationFrame(raf);
        };

        rafId = requestAnimationFrame(raf);
      } catch (error) {
        console.error("Erreur lors du chargement de Lenis :", error);
      }
    };

    const scheduleLenis = () => {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(() => {
          initLenis();
        });
      } else {
        setTimeout(() => {
          initLenis();
        }, 300);
      }
    };

    scheduleLenis();

    const updateTimer = setTimeout(() => {
      if (isMounted) setShowUpdatePopup(true);
    }, 1200);

    const photosTimer = setTimeout(() => {
      if (isMounted) setShowPhotosPopup(true);
    }, 1800);

    return () => {
      isMounted = false;
      clearTimeout(updateTimer);
      clearTimeout(photosTimer);

      if (rafId) {
        cancelAnimationFrame(rafId);
      }

      if (lenisInstance) {
        lenisInstance.destroy();
      }
    };
  }, []);

  return (
    <div className="min-h-screen relative">
      <Navbar />
      <Hero />

      <Suspense fallback={null}>
        <About />
        <Services />
        <Gallery />
        <Testimonials />
        <Contact />
        <Appointment />
        <Footer />
      </Suspense>

      {/*
      <div className="fixed bottom-5 left-5 z-50 flex flex-col gap-3">
        {showPhotosPopup && (
          <div className="animate-in fade-in slide-in-from-bottom-3 duration-500">
            <div className="flex items-center gap-3 rounded-2xl border border-white/20 bg-white/85 px-4 py-3 shadow-xl backdrop-blur-md">
              <div className="flex h-3 w-3">
                <span className="relative inline-flex h-3 w-3">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-sky-400 opacity-60"></span>
                  <span className="relative inline-flex h-3 w-3 rounded-full bg-sky-500"></span>
                </span>
              </div>

              <div className="flex flex-col">
                <span className="text-sm font-semibold text-gray-900">
                  Galerie en cours d'achevinement
                </span>
                <span className="text-xs text-gray-600">
                  De nouveaux visuels seront prochainement ajoutés au site.
                </span>
              </div>
            </div>
          </div>
        )}

        {showUpdatePopup && (
          <div className="animate-in fade-in slide-in-from-bottom-3 duration-500">
            <div className="flex items-center gap-3 rounded-2xl border border-white/20 bg-white/85 px-4 py-3 shadow-xl backdrop-blur-md">
              <div className="flex h-3 w-3">
                <span className="relative inline-flex h-3 w-3">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-400 opacity-60"></span>
                  <span className="relative inline-flex h-3 w-3 rounded-full bg-amber-500"></span>
                </span>
              </div>

              <div className="flex flex-col">
                <span className="text-sm font-semibold text-gray-900">
                  Modifications en cours
                </span>
                <span className="text-xs text-gray-600">
                  Des ajustements sont actuellement en cours d’application.
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
      */}
    </div>
  );
};

export default Home;